
    var riot = require('riot')
    //src: starling/src/tags/menu/items/menu-item-paste.html
riot.tag2('menu-item-paste',
  '<i class="fa fa-paste floating-menu_icon"></i> <span class="floating-menu_label">{pasteItemText()}</span> <span class="floating-menu_shortcut">{shortcutText()}</span>',
  '',
  'class="floating-menu_item" onclick="{paste}"', function(opts) {
'use strict';

var _this = this;

var _copyPaste = require('lib/copy-paste');

var _copyPaste2 = _interopRequireDefault(_copyPaste);

var _util = require('lib/util');

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var canvas = this.parent.opts.canvas;
var isMac = canvas.isMac;

this.shortcutText = function () {
  var parent = _this.parent;
  var getActiveNodeTag = parent.getActiveNodeTag;

  if (parent.singleCardMenu || getActiveNodeTag && getActiveNodeTag()) {
    return isMac ? '⇧⌘V' : 'Ctrl+Shift+V';
  }

  return isMac ? '⌘V' : 'Ctrl+V';
};

this.pasteItemText = function () {
  if (_this.parent.singleCardMenu || _this.parent.getActiveNodeTag && _this.parent.getActiveNodeTag()) {
    return "Paste as parts";
  } else {
    return "Paste";
  }
};

this.paste = function (e) {
  var nodeTag = _this.parent.getActiveNodeTag ? _this.parent.getActiveNodeTag() : null;
  if (_this.parent.singleCardMenu || nodeTag) {
    canvas.setSelectedElement(nodeTag, false);
    _copyPaste2.default.paste({ canvas: canvas, pasteWithinEnabled: true });
  } else {
    _copyPaste2.default.paste({
      canvas: canvas,
      position: {
        x: _this.parent.x,
        y: _this.parent.y
      }
    });
  }

  _eventTracking2.default.track({
    category: (0, _util.getTrackingLabel)(_this.parent),
    action: 'Paste',
    label: 'Selection'
  });

  _this.parent.hide();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('menu-item-paste')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/menu/items/menu-item-paste.html
// module id = 709
// module chunks = 0